import { useLocation } from "react-router-dom";
import { ExtensionPointRenderer } from "./ExtensionPointRenderer";

/**
 * Renders extensions whose activePages match the current route.
 * Place this inside the Layout after <Outlet /> to automatically
 * show app extensions on matching pages.
 */
export function RouteExtensionPoints() {
  const location = useLocation();

  return <ExtensionPointRenderer pathname={location.pathname} />;
}
